import { defaultTo, isEmpty } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { Option } from '../form';
import { Label } from '../form/label';
import type { MultiSelect } from '../form/select/multi-select';

type FilterProps = {
  label: string;
  className?: string;
};

export const Filter = ({ className, label, children }: PropsWithChildren<FilterProps>) => (
  <Label label={label} labelPosition="top" className={className}>
    {children}
  </Label>
);

const emptyValues: string[] = [];

type MultiValueFilterProps = {
  MultiValueFormComponent: typeof MultiSelect;
  value?: string[];
  onChange: (value: string[]) => void;
  label: string;
  options: Option[] | string[] | Record<string, string>;
  displayOptionsFilter?: boolean;
  className?: string;
};


export const MultiValueFilter = ({ MultiValueFormComponent, className, value, onChange, label, options, displayOptionsFilter = false }: MultiValueFilterProps) => {
  const [currentValues, setCurrentValues] = useState(defaultTo(value, emptyValues));

  useEffect(() => setCurrentValues(defaultTo(value, emptyValues)), [value]);

  const handleChange = useCallback((values: string[]) => {
    setCurrentValues(values);
    onChange(values);
  }, [onChange]);

  if (isEmpty(options)) {
    return null;
  }

  return (
    <Filter label={label}>
      <MultiValueFormComponent
        className={className}
        values={currentValues}
        onValueChange={handleChange}
        options={options}
        displayOptionsFilter={displayOptionsFilter}
        variant="small"
      />
    </Filter>
  );
};
